import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ManagedServicesProviderComponent } from './managed-services-provider.component';

const routes: Routes = [
  { path: 'msp', component: ManagedServicesProviderComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ManagedServicesProviderRoutingModule { }
